import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import SearchIcon from "@material-ui/icons/Search";

const useStyles = makeStyles(() => ({
  wrapper: {
    display: "flex",
    justifyContent: "flex-end",
    width: "100%",
  },
  searchContainer: {
    display: "flex",
    alignItems: "center",
    backgroundColor: "transparent",
    border: "1px solid rgba(255, 255, 255, 0.6)", // Dim white border
    borderRadius: "4px",
    padding: "4px 8px",
    color: "rgba(255, 255, 255, 0.6)",
    maxWidth: "300px",
    width: "100%",
    transition: "border-color 0.2s ease-in-out",
    "&:hover, &:focus-within": {
      borderColor: "#fff", // Bright white on hover/focus
      color: "#fff",
    },
  },
  searchInput: {
    border: "none",
    outline: "none",
    backgroundColor: "transparent",
    color: "rgba(255, 255, 255, 0.6)",
    marginLeft: "8px",
    width: "100%",
    fontSize: "14px",
    transition: "color 0.2s ease-in-out",

    "&::placeholder": {
      color: "rgba(255, 255, 255, 0.6)",
      opacity: 1,
    },

    "&:hover, &:focus": {
      color: "#fff",
      "&::placeholder": {
        color: "#fff",
      },
    },
  },
  icon: {
    color: "rgba(255, 255, 255, 0.6)",
    transition: "color 0.2s ease-in-out",
    "$searchContainer:hover &": {
      color: "#fff",
    },
  },
}));

export default function CustomSearch({ value, onChange, placeholder }) {
  const classes = useStyles();

  return (
    <div className={classes.wrapper}>
      <div className={classes.searchContainer}>
        <SearchIcon className={classes.icon} />
        <input
          type="text"
          value={value}
          onChange={onChange}
          placeholder={placeholder}
          className={classes.searchInput}
        />
      </div>
    </div>
  );
}
